import script from "./CharacterDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./CharacterDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./CharacterDisplay.vue?vue&type=style&index=0&id=91d357d8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91d357d8"]])

export default __exports__